var voted_users_rtlignore_default = {
  "container": "dzZjL",
  "webview": "gSevj",
  "avatar_list": "vvJcI",
  "avatar": "bNsN3",
  "user_avatar": "grw80",
  "modal": "T3hq9",
  "voted_users_modal": "_3TAx5",
  "overlay": "cRny2",
  "user_card": "cqXwv",
  "user_name": "lNGxz",
  "voted_users_modal_header": "HOhAX",
  "cta": "atAck",
  "close_icon": "QdFX5",
  "title": "tv2iK",
  "member_list_container": "VteYC",
  "member_list": "mebTR",
  "loader": "_5Zk2i",
  "anonymous_counter": "ZuCEt",
  "spinner": "vvJ1U",
  "spin": "wSP--"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
